import { useState } from "react";
import { Button, Stack } from "@mui/material";
import MDBox from "components/MDBox"; // adjust path if different
import { useTranslation } from "react-i18next";
import WorkloadAnalysisFlow from "./ManpowerPlanning";
import ManpowerAnalysisPage from "./Analysis";
import MDButton from "components/MDButton";
import { buttonStyles } from "services/utils";
import { ReactFlowProvider } from "reactflow";

const AnalysisContainerPage = () => {
  const { t } = useTranslation();
  const [view, setView] = useState(0);

  return (
    <MDBox>
      <MDBox mb={2}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems="center">
          <MDButton
            sx={{ ...buttonStyles(view === 0), width: { xs: "100%", sm: "auto" } }}
            variant={view === 0 ? "contained" : "outlined"}
            onClick={() => setView(0)}
          >
            {t("analysis.workload")}
          </MDButton>
          <MDButton
            sx={{ ...buttonStyles(view === 1), width: { xs: "100%", sm: "auto" } }}
            variant={view === 1 ? "contained" : "outlined"}
            onClick={() => setView(1)}
          >
            {t("analysis.manpower")}
          </MDButton>
        </Stack>
      </MDBox>
      {view === 0 ? (
        <ReactFlowProvider>
          <WorkloadAnalysisFlow />
        </ReactFlowProvider>
      ) : (
        <ManpowerAnalysisPage />
      )}
    </MDBox>
  );
};

export default AnalysisContainerPage;
